module.exports = __webpack_public_path__ + "static/img/IMG_20241205_102808_edit_174903074479477.a214ed53.jpg";